import React from 'react';
import classes from './description.scss';
const Description = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
  className: classes.descriptionText
}, "We'll send a PDF of this design direct to your inbox. ", /*#__PURE__*/React.createElement("br", null), " Select what else to include:"));
export default Description;